import { HomeParaguas } from './HomeParaguas';

export type { TypeHomeParaguasProps } from './types';
export default HomeParaguas;
